import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStair = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		style: {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "1.7px"
		},
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 2.5,
				y: 7,
				width: 19,
				height: 10
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 7.25,
				y1: 7,
				x2: 7.25,
				y2: 17
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 12,
				y1: 7,
				x2: 12,
				y2: 17
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 16.75,
				y1: 7,
				x2: 16.75,
				y2: 17
			})
		]
	})
});
export default SvgStair;
